import Cookies from "js-cookie"
import config from "../environments/generated.config"

const { cookie, feature_toggle } = config

const cookieEnable = feature_toggle.cookie_enabled
const cookieForceHttps = cookie.force_https
const cookieDomain = cookie.domain
const cookieExpiresDays = 1
const cookieKeyClientId = "client_cod"
const cookieKeyUserId = "user_id"
const cookieKeyUserName = "user_name"
const cookieKeyUserToken = "session_token"
const cookieConfig = {
  domain: cookieDomain,
  path: "/",
  secure: cookieForceHttps,
}

const disabled = function () {
  return !cookieEnable
}

const getCookie = function (cookieKey) {
  if (disabled()) {
    return ""
  }

  const cookieValue = Cookies.get(cookieKey, cookieConfig)

  return cookieValue
}

const setCookie = function (cookieKey, cookieValue) {
  if (disabled() || !cookieValue) {
    return ""
  }
  return Cookies.set(cookieKey, cookieValue, { ...cookieConfig, expires: cookieExpiresDays })
}

const removeCookie = function (cookieKey) {
  if (disabled()) {
    return ""
  }
  return Cookies.remove(cookieKey, cookieConfig)
}

export function clearSessionToken() {
  return removeCookie(cookieKeyUserToken)
}

export function clearUserId() {
  return removeCookie(cookieKeyUserId)
}

export function clearUserName() {
  return removeCookie(cookieKeyUserName)
}

export function clearClientId() {
  return removeCookie(cookieKeyClientId)
}

export function clearCookies() {
  clearSessionToken()
  clearUserId()
  clearUserName()
  clearClientId()
}

export function getSessionToken() {
  return getCookie(cookieKeyUserToken)
}

export function getUserId() {
  return Number(getCookie(cookieKeyUserId))
}

export function getUserName() {
  return getCookie(cookieKeyUserName)
}

export function getClientId() {
  return getCookie(cookieKeyClientId)
}

export function setSessionToken(cookieValue) {
  return setCookie(cookieKeyUserToken, cookieValue)
}

export function setUserId(cookieValue) {
  return setCookie(cookieKeyUserId, cookieValue.toString())
}

export function setUserName(cookieValue) {
  return setCookie(cookieKeyUserName, cookieValue)
}

export function setClientId(cookieValue) {
  return setCookie(cookieKeyClientId, cookieValue)
}
